import React from "react";
import Slider from "react-slick";
import BannerImage from "../../lib/Json/homePage.json";

export default function SolutionSlider() {
  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    fade: true,
    easing: "ease-in-out",
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {BannerImage?.slide_banner.map((banner) => (
        <div key={banner.name}>
          <img
            src={banner.url}
            alt={banner.name}
            className="w-full h-full object-contain"
          />
        </div>
      ))}
    </Slider>
  );
}
